import React, {useCallback} from 'react';
import {Box, Grid, IconButton, withStyles} from '@material-ui/core';
import {FileWithPath, useDropzone} from 'react-dropzone';
import {BiometricsStyles} from 'assets/tss/layouts/components';
import CheckIcon from '@material-ui/icons/Check';
import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {useAlert} from 'hooks';
import EfeModalMsg from 'components/efe-modal-msg/EfeModalMsg';

const MB_SIZE = 1048576;
const KB_SIZE = 1024;
const errorModal = {
    data: {
        process: 'Carga de archivos',
        message: ' ',
        errors: [''],
    },
};

EfeDragAndDrop.propTypes = {
    maxSizeFile: PropTypes.number.isRequired,
    numFiles: PropTypes.number.isRequired,
    file: PropTypes.string.isRequired,
    fileList: PropTypes.array.isRequired,
    loadFile: PropTypes.func.isRequired,
    deleteFile: PropTypes.func.isRequired,
    length: PropTypes.number,
    formatOverride: PropTypes.string,
    formatOverrideLabel: PropTypes.string,
};

function EfeDragAndDrop(
    props: InferPropTypes<typeof EfeDragAndDrop.propTypes, typeof BiometricsStyles>
) {
    const {
        classes,
        maxSizeFile,
        numFiles,
        fileList,
        loadFile,
        deleteFile,
        formatOverride,
        formatOverrideLabel,
    } = props;
    const {showAlert, defaultError, genericError, showAlertError, closeAlert} = useAlert();
    
    const onDrop = useCallback((selectedFiles) => {
        if (selectedFiles && selectedFiles.length) {
            const fileItem = selectedFiles[0];
            loadFile(fileItem);
        }
    }, []);
    const {getRootProps, getInputProps} = useDropzone({
        accept: formatOverride || 'image/jpeg, image/png, .pdf',
        maxFiles: numFiles,
        maxSize: maxSizeFile ? maxSizeFile * 1024 * 1024 : 10485760,
        validator: nameLengthValidator,
        onDrop,
    });
    const handleDeleteFile = (index: number) => {
        if (index > -1) {
            deleteFile(index);
        }
    };

    function nameLengthValidator(file: File) {
        const maxSize = maxSizeFile ? maxSizeFile * 1024 * 1024 : 10485760;
        if (file.size > maxSize){
            errorModal.data.errors= [`El archivo ${file.name} supera el tama\u00F1o m\u00E1ximo permitido.`];
            showAlertError(errorModal, '');
        }
        return null;
    }

    function convertHumanSize(file: FileWithPath): string {
        if (file.size >= 1048576) {
            return `${file.name} - ${Math.round(file.size / MB_SIZE)} MB`;
        }
        return `${file.name} - ${Math.round(file.size / KB_SIZE)} KB`;
    }
    return (
        <Grid container>
            {showAlert && (
                <EfeModalMsg
                    error={genericError}
                    open={showAlert}
                    defaultError={defaultError}
                    handleAction={closeAlert}
                />
            )}
            <Grid item xs={12}>
                <Box className={classes.body}>
                    <div {...getRootProps({className: classes.baseStyle})}>
                        <input {...getInputProps()} />
                        <p>
                            <b>{'Busca tus documentos'}</b>
                            {' o arrastra y su\u00E9ltalos aqu\u00ED'}
                        </p>
                        <p>
                            {'Tama\u00F1o m\u00E1ximo: '}
                            {maxSizeFile}
                            {' MB'}
                        </p>
                        <p>{formatOverrideLabel || 'Formatos: .JPG, .PNG y .PDF'}</p>
                    </div>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <aside>
                    <ul>
                        {fileList &&
                            fileList.map((fileItem: FileWithPath, index) => (
                                <li key={index} className={classes.filesList}>
                                    <span className={classes.iconLabel}>
                                        <CheckIcon
                                            fontSize='small'
                                            style={{
                                                color: 'green',
                                            }}></CheckIcon>
                                        <span>{convertHumanSize(fileItem)}</span>
                                        <span style={{marginLeft: 'auto'}}>
                                            <IconButton onClick={() => handleDeleteFile(index)}>
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </span>
                                    </span>
                                </li>
                            ))}
                    </ul>
                </aside>
            </Grid>
        </Grid>
    );
}

export default withStyles(BiometricsStyles)(EfeDragAndDrop);
